import { locations } from './locations';
export var v4 = {
    namespaced: true,
    modules: { locations: locations },
};
